import { Box, BoxProps } from 'rebass'
import { styled } from '../../styles/settings'

const EditTeamDetailFieldWrapper = styled(Box)<BoxProps>`
  max-width: 420px;
`

export default EditTeamDetailFieldWrapper
